export var QuestionnaireTemplateVersionStatus;
(function (QuestionnaireTemplateVersionStatus) {
    QuestionnaireTemplateVersionStatus["Archived"] = "archived";
    QuestionnaireTemplateVersionStatus["Draft"] = "draft";
    QuestionnaireTemplateVersionStatus["Published"] = "published";
})(QuestionnaireTemplateVersionStatus || (QuestionnaireTemplateVersionStatus = {}));
//# sourceMappingURL=questionnaire-template-version-status.js.map